import { render } from "./CareerPage.vue?vue&type=template&id=1b6799ec&scoped=true"
import script from "./CareerPage.vue?vue&type=script&lang=js"
export * from "./CareerPage.vue?vue&type=script&lang=js"

import "./CareerPage.vue?vue&type=style&index=0&id=1b6799ec&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6799ec"]])

export default __exports__